<template>
  <v-card flat class="pa-6">
    <v-card-title class="text-h6 primary--text mb-4">
      {{ $t("game_colors_and_theme") }}
    </v-card-title>

    <v-card-text>
      <v-row dense>
        <template v-if="gameType === 'Game'">
          <v-col cols="12">
            <v-alert type="info" text prominent>
              این بازی از رنگ‌های سفارشی استفاده نمی‌کند (پس‌زمینه از تصویر
              bgMain است).
            </v-alert>
          </v-col>
        </template>

        <template v-else-if="gameType === 'MeepMeepProRunner'">
          <v-col
            v-for="(config, key) in colorsSchema"
            :key="key"
            cols="12"
            md="6"
          >
            <h5 class="mb-2 font-weight-medium primary--text">
              {{ config.label || key }}
            </h5>
            <color-picker
              :value="gameConfig.colors?.[key]"
              @input="updateColor(key, $event)"
            />
            <small v-if="config.hint" class="grey--text caption mt-1 d-block">
              {{ config.hint }}
            </small>
          </v-col>

          <!-- اگر هیچ رنگی در schema نبود -->
          <v-col v-if="!Object.keys(colorsSchema).length" cols="12">
            <v-alert type="info" text prominent class="mt-4">
              تنظیمات رنگ برای این بازی تعریف نشده است.
            </v-alert>
          </v-col>
        </template>

        <v-col v-else cols="12">
          <v-alert type="warning" text prominent>
            نوع بازی نامعتبر است – لطفاً نوع بازی را انتخاب کنید.
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ColorPicker from "@/view/pages/qrland/components/colorPicker.vue";

export default {
  name: "TabColors",
  components: { ColorPicker },
  props: {
    value: { type: Object, required: true },
    schema: { type: Object, required: true },
  },
  computed: {
    gameConfig: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    gameType() {
      return this.gameConfig?.type || null;
    },
    colorsSchema() {
      return this.schema?.colorsConfig || {};
    },
  },
  methods: {
    updateColor(key, newColor) {
      // Use Vue.set to ensure reactivity
      if (!this.gameConfig.colors) {
        this.$set(this.gameConfig, "colors", {});
      }
      this.$set(this.gameConfig.colors, key, newColor);
      this.$emit("input", { ...this.gameConfig });
    },
  },
};
</script>

<style scoped>
h5 {
  font-size: 1.05rem;
}
</style>
